import React, { useReducer } from 'react'

import { requirePasswordDialogInitialState } from './store/State'

import requirePasswordDialogReducer from './store/Reducer'

import RequirePasswordDialogService from './Service'

const requirePasswordDialogContext = {
  state: requirePasswordDialogInitialState,
  handlers: {
    toggleDialog: () => {},
    setPassword: (_password: string) => {},
    checkPassword: () => {},
    checkSubmission: () => true
  }
}

export type RequirePasswordDialogContext = typeof requirePasswordDialogContext

export const RequirePasswordDialogContextProvider = React.createContext<RequirePasswordDialogContext>(
  requirePasswordDialogContext
)

const Provider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(requirePasswordDialogReducer, requirePasswordDialogInitialState)

  const handlers = {
    toggleDialog: RequirePasswordDialogService.toggleDialog(state, dispatch),
    setPassword: RequirePasswordDialogService.setPassword(state, dispatch),
    checkPassword: RequirePasswordDialogService.checkPassword(state, dispatch),
    checkSubmission: RequirePasswordDialogService.checkSubmission(state, dispatch)
  }

  const contextValue = {
    ...requirePasswordDialogContext,
    state,
    handlers
  }

  return (
    <RequirePasswordDialogContextProvider.Provider value={contextValue}>
      {children}
    </RequirePasswordDialogContextProvider.Provider>
  )
}

export default Provider
